import React from "react"
import styled from "styled-components"
import { P, H1, Container, AbsoluteImg } from "../general/GeneralStyles"

const PageContainer = styled.div`
  position: relative;

  img {
    position: absolute;
    z-index: -1;
  }

  #paintdrop {
    right: 0;
    top: 10%;
  }

  #paint {
    left: 0;
    top: 30%;
  }

  #paintblue {
    left: 0;
    bottom: 20%;
    display: ${props => (props.hideBluePaint ? "none" : "inherit")};
  }

  #clayrocket {
    right: 0;
    bottom: 10%;
  }

  ${AbsoluteImg} {
    @media (max-width: ${props => props.theme.mediumBreakpoint}) {
      display: none!important;
    }
  }
`

const ContentContainer = styled(Container)`
  padding-top: 100px;

  ${H1} {
    margin-bottom: 80px;
  }

  ${P} {
    font-size: 12px;
  }
`

const Content = props => {
  return (
    <PageContainer hideBluePaint={props.hideBluePaint}>
      <AbsoluteImg id="paint" src="/images/absolute/paint.png" alt="paint" />
      <AbsoluteImg
        id="paintdrop"
        src="/images/absolute/paintdrop.png"
        alt="paintdrop"
      />
      <AbsoluteImg
        id="paintblue"
        src="/images/absolute/paint-blue.png"
        alt="blue paint"
      />
      <AbsoluteImg
        id="clayrocket"
        src="/images/absolute/clayrocket.png"
        alt="rocket made out of clay"
      />
      <ContentContainer>{props.children}</ContentContainer>
    </PageContainer>
  )
}

export default Content
